// src/pages/ProjectsPage.js
import { useState, useEffect, useMemo, memo } from 'react';
import useAuth from '../../hooks/useAuth';
import api from '../../services/api';
import AnalyticsControl from '../../components/project/AnalyticsControl';
import AddProjectForm from '../../components/project/AddProjectForm';
import ProjectTableRow from '../../components/project/ProjectTableRow';
import { getProjectUsers } from '../../services/projectService';

const ProjectsPage = () => {
  const { user } = useAuth();

  if (!user?.superuser) return <div className="main-content">Нет прав.</div>;

  return (
    <div className="main-content">
      <div className="page-header mb-4">
        <h1>Управление проектами</h1>
      </div>

      <AnalyticsControl />
      <AddProjectForm />
      <ProjectContextLoader />
    </div>
  );
};

// Компонент для загрузки и отображения проектов
const ProjectContextLoader = memo(() => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get('/projects');
        const data = res.data;

        const initialProjects = Array.isArray(data.projects) ? data.projects : [];

        const projectsWithUsers = await Promise.all(
          initialProjects.map(async (project) => {
            try {
              const users = await getProjectUsers(project.id);
              return { ...project, users: users || [] };
            } catch (err) {
              console.error(`Ошибка загрузки пользователей для проекта ${project.id}:`, err);
              return { ...project, users: [] };
            }
          })
        );

        setProjects(projectsWithUsers);
      } catch (err) {
        console.error('Ошибка при загрузке данных:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Мемоизация отображения таблицы
  const tableContent = useMemo(() => {
    if (loading) return <div className="main-content">Загрузка...</div>;

    if (projects.length > 0) {
      return (
        <table className="table table-bordered table-striped-columns">
          <thead>
            <tr>
              <th>Проект</th>
              <th className="text-center">Пользователи</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {projects.map((project) => (
              <ProjectTableRow key={project.id} project={project} />
            ))}
          </tbody>
        </table>
      );
    } else {
      return <p>Нет проектов.</p>;
    }
  }, [loading, projects]);

  return tableContent;
});

export default ProjectsPage;
